export default "/images/vendorAffinity.svg?c53bb6ac458c9d20335f453e435160ed";